import type { DefaultErrorProps } from '@grandvisionhq/www-next/pages/error'

export const defaultErrorProps: DefaultErrorProps = {
  title: 'Algo parece estar quebrado...',
  subheader: 'Parece que você ficou um pouco perdido',
  buttonText: 'Voltar à página inicial',
}
